import BottleDeposit from './components/BottleDeposit';
import CouponsAndPromos from './components/CouponsAndPromos';
import Duties from './components/Duties';
import DutyUnpaidEstimate from './components/DutyUnpaidEstimate';
import GiftCards from './components/GiftCards';
import LoyaltyPoints from './components/LoyaltyPoints';
import LoyaltyPointsEarned from './components/LoyaltyPointsEarned';
import PointsSummary from './components/PointsSummary';
import Shipping from './components/Shipping';
import SubTotal from './components/SubTotal';
import Taxes from './components/Taxes';
import TaxesIncludedInPrice from './components/TaxesIncludedInPrice';
import Tip from './components/Tip';
import Total from './components/Total';
import TotalRemaining from './components/TotalRemaining';

const Summary = (props) => {
  const {
    cartOrOrder,
    showGiftCards = false,
    showLoyaltyPoints = false,
    showTotalRemaining = true,
    type,
    isOrder = false
  } = props;

  return (
    <>
      <SubTotal cartOrOrder={cartOrOrder} />
      <Shipping cartOrOrder={cartOrOrder} />
      <Taxes cartOrOrder={cartOrOrder} />
      <Duties cartOrOrder={cartOrOrder} />
      <BottleDeposit cartOrOrder={cartOrOrder} />
      <Tip cartOrOrder={cartOrOrder} />
      <Total cartOrOrder={cartOrOrder} type={type} />
      <PointsSummary cartOrOrder={cartOrOrder} />
      {showGiftCards && <GiftCards cartOrOrder={cartOrOrder} />}
      {showLoyaltyPoints && <LoyaltyPoints cartOrOrder={cartOrOrder} />}
      {showTotalRemaining &&
        (showGiftCards || showLoyaltyPoints) &&
        !isOrder && <TotalRemaining />}
      <TaxesIncludedInPrice cartOrOrder={cartOrOrder} />
      <DutyUnpaidEstimate cartOrOrder={cartOrOrder} />
      <CouponsAndPromos cartOrOrder={cartOrOrder} />
      <LoyaltyPointsEarned cartOrOrder={cartOrOrder} />
    </>
  );
};

export default Summary;
